import styled from "styled-components";

export const RequestsSectionSection = styled.div.attrs({ className: "mt-8" })``;
